// TrainingModeModal.jsx
import { useState } from 'react';
import { Star, X } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { useTranslation } from 'react-i18next';

const TrainingModeModal = ({ isOpen, setIsOpen, startNewDay }) => {
  const { t } = useTranslation();
  const [selectedDay, setSelectedDay] = useState(1);
  const [selectedMoney, setSelectedMoney] = useState(100);
  const [selectedRating, setSelectedRating] = useState(30);

  const handleStart = () => {
    const gameState = {
      day: parseInt(selectedDay),
      money: parseInt(selectedMoney),
      rating: parseInt(selectedRating),
      stats: {
        totalRevenue: 0,
        totalCustomers: 0
      },
      dayComplete: false,
      trainingMode: true
    };
    startNewDay('trainingMode', gameState);
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-start justify-center p-4">
      <Card className="w-full max-w-lg mx-auto bg-white shadow-[0_0_15px_rgba(0,0,0,0.1)]">
        <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
          <CardTitle className="text-xl font-bold">{t('training.title')}</CardTitle>
          <Button
            variant="outline"
            size="sm"
            className="h-8 w-8 p-0 hover:bg-stone-100"
            onClick={() => setIsOpen(false)}
          >
            <X className="h-4 w-4" />
            <span className="sr-only">{t('training.close')}</span>
          </Button>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div className="grid gap-6">
              <div>
                <div className="flex justify-between items-center mb-2">
                  <label className="text-stone-800">
                    {t('training.day')}
                  </label>
                  <span className="text-stone-800">{selectedDay}</span>
                </div>
                <input
                  type="range"
                  min="1"
                  max="20"
                  value={selectedDay}
                  onChange={(e) => setSelectedDay(e.target.value)}
                  className="w-full accent-stone-800"
                />
              </div>

              <div>
                <div className="flex justify-between items-center mb-2">
                  <label className="text-stone-800">
                    {t('training.money')}
                  </label>
                  <span className="text-stone-800">
                    {t('game.currency', { amount: selectedMoney })}
                  </span>
                </div>
                <input
                  type="range"
                  min="5"
                  max="1000"
                  step="5"
                  value={selectedMoney}
                  onChange={(e) => setSelectedMoney(e.target.value)}
                  className="w-full accent-stone-800"
                />
              </div>

              <div>
                <div className="flex justify-between items-center mb-2">
                  <label className="text-stone-800">
                    {t('training.rating')}
                  </label>
                  <span className="text-stone-800 flex items-center gap-1">
                    {(selectedRating / 10).toFixed(1)}
                    <Star className="fill-yellow-400 text-yellow-400 shrink-0" size={16} />
                  </span>
                </div>
                <input
                  type="range"
                  min="1"
                  max="50"
                  value={selectedRating}
                  onChange={(e) => setSelectedRating(e.target.value)}
                  className="w-full accent-stone-800"
                />
              </div>
            </div>

            <div className="flex justify-center pt-2">
              <div className="flex gap-2">
                <Button
                  variant="outline"
                  onClick={() => setIsOpen(false)}
                  className="border-stone-800 text-stone-800 hover:bg-stone-50"
                >
                  {t('training.cancel')}
                </Button>
                <Button
                  onClick={handleStart}
                  className="bg-stone-800 hover:bg-stone-900 text-white transition-colors"
                >
                  {t('training.start')}
                </Button>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export const showTrainingModal = (setIsOpen) => {
  setIsOpen(true);
};

export default TrainingModeModal;